document.querySelectorAll(".reveal-btn").forEach((button) => {

  button.addEventListener("click", () => {

    const img = button.querySelector("img");
    const overlay = button.querySelector(".reveal-overlay");

    // IF OVERLAY EXISTS = REVEAL IMAGE
    if (overlay) {

      // replace all image classes
      img.className =
        "h-full w-full object-cover transition-all duration-500 scale-100 blur-0";

      // remove overlay
      overlay.remove();

    } else {

      // restore original image classes
      img.className =
        "reveal-img h-full w-full object-cover transition-all duration-500 scale-[1.03] blur-[6px]";

      // recreate overlay
      const newOverlay = document.createElement("span");

      newOverlay.className =
        "reveal-overlay absolute inset-0 flex items-center justify-center";

      newOverlay.innerHTML = `
        <span class="rounded-md bg-brand-dark/60 px-4 py-1.5 font-serif-display text-xl font-black italic text-primary-foreground shadow-lg">
          Reveal…
        </span>
      `;

      button.appendChild(newOverlay);

    }

  });

});
function initStickyBar() {

  const stickyBar = document.querySelector(".fixed.inset-x-0.bottom-0");

  if (!stickyBar) return;

  function toggleStickyBar() {

    if (window.scrollY > 200) {

      stickyBar.classList.remove(
        "pointer-events-none",
        "translate-y-full",
        "opacity-0"
      );

      stickyBar.classList.add(
        "translate-y-0",
        "opacity-100"
      );

    } else {

      stickyBar.classList.add(
        "pointer-events-none",
        "translate-y-full",
        "opacity-0"
      );

      stickyBar.classList.remove(
        "translate-y-0",
        "opacity-100"
      );

    }

  }

  // run on scroll
  window.addEventListener("scroll", toggleStickyBar);

  // run once on load
  toggleStickyBar();

}

const accordionContent = {
  "radix-:r1:": [
    { icon: "check", text: "Helps replenish minerals in enamel to support strong, healthy teeth" },
    { icon: "check", text: "Helps brighten smile naturally" },
    { icon: "check", text: "Activates saliva to help rinse away food particles" },
    { icon: "check", text: "Supports the mouth's natural pH balance" },
    { icon: "check", text: "Creates an oral environment less favorable to harmful bacteria" },
    { icon: "check", text: "Freshens breath naturally with every chew" },
    { icon: "check", text: "Works between brushes for a cleaner-feeling mouth" },
    { icon: "check", text: "Plant-based, peroxide-free, sugar-free" }
  ],
  "radix-:r2:": [
    { icon: "x", text: "So popular it occasionally sells out" }
  ],
  "radix-:r3:": [
    { icon: "x", text: "So popular it occasionally sells out" }
  ],
  "radix-:r5:": [
    { icon: "check", text: "Up to 20x more plaque removal than manual brushing" },
    { icon: "check", text: "Pressure sensor stops you from brushing too hard" },
    { icon: "check", text: "App tracks your habits and personalizes your routine" },
    { icon: "check", text: "14-day battery life with premium travel case included" }
  ],
  "radix-:r7:": [
    { icon: "x", text: "Premium price point" },
    { icon: "x", text: "Some users report durability issues after 12 to 18 months" }
  ],
  "radix-:r9:": [
    { icon: "check", text: "Eases occasional discomfort" },
    { icon: "check", text: "SLS-free formula gentle enough for daily use" },
    { icon: "check", text: "Helps with surface whitening" }
  ],
  "radix-:rb:": [
    { icon: "x", text: "Potassium nitrate dulls the signal, it does not address mineral loss in enamel" },
    { icon: "x", text: "Relief fades when you stop using it consistently" }
  ],
  "radix-:rd:": [
    { icon: "check", text: "PrecisionPulse technology reaches gaps brushing and flossing leave behind" },
    { icon: "check", text: "#1 dentist-recommended water flosser brand" },
    { icon: "check", text: "9 weeks battery life, shower-proof and travel-friendly" },
  ],
  "radix-:rf:": [
    { icon: "x", text: "Small learning curve on first use" },
    { icon: "x", text: "Some durability concerns reported after 12 to 18 months" }
  ],
  "radix-:rh:": [
    { icon: "check", text: "100% medical-grade stainless steel, rust-resistant and dishwasher-safe" },
    { icon: "check", text: "U-shaped curve reaches every corner of the tongue without gagging" },
    { icon: "check", text: "Two-pack with travel cases under $10" }
  ],
  "radix-:rj:": [
    { icon: "x", text: "Use gentle pressure, aggressive scraping can disrupt the oral microbiome" },
    { icon: "x", text: "Slight metallic taste initially for some users" },
    { icon: "x", text: "Thin handles feel less grippy than some prefer" }
  ],
  "radix-:rl:": [
    { icon: "check", text: "Leave-on formula, no rinsing or removal needed" },
    { icon: "check", text: "LED accelerator light boosts results in 3 minutes" },
    { icon: "check", text: "Precise wand applicator, faster and less fussy than strips" },
    { icon: "check", text: "Hydrogen peroxide formula is one of the most studied whitening agents available over the counter" }
  ],
  "radix-:rn:": [
    { icon: "x", text: "Hydrogen peroxide works on surface stains but doesn't address the mineral health of enamel underneath" },
    { icon: "x", text: "LED light has a limited lifespan and batteries can't be replaced" },
    { icon: "x", text: "Some users report gel sliding off with excess saliva" }
  ],
  "radix-:rp:": [
    { icon: "check", text: "Alcohol-free formula, no burn or oral tissue dryness" },
    { icon: "check", text: "6-in-1 coverage including breath, gums, and fluoride support" },
    { icon: "check", text: "Widely available and affordable" }
  ],
  "radix-:rr:": [
    { icon: "x", text: "Works best as a complement to brushing, not a standalone oral care step" },
  ],
  "radix-:rt:": [
    { icon: "check", text: "Helps reinforce and protect enamel with hydroxyapatite" },
    { icon: "check", text: "Supports a balanced oral microbiome that helps maintain healthy pH levels in the mouth" },
    { icon: "check", text: "Brightens and whitens without harsh bleaching agents" },
    { icon: "check", text: "Rich foamy texture with a long-lasting refreshing mint flavor" }
  ],
  "radix-:rv:": [
    { icon: "x", text: "Hydroxyapatite is backed by many published studies, though it is a newer mainstream alternative to fluoride" },
  ]
};

function buildAccordionContent(items) {
  const container = document.createElement('div');
  container.className = 'pt-0 pb-5';

  const list = document.createElement('ul');
  list.className = 'space-y-2';

  items.forEach((item) => {
    const li = document.createElement('li');
    li.className = 'flex gap-2 text-[15px] leading-relaxed text-foreground/85';

    const iconClass = item.icon === 'check' ? 'text-success' : 'text-destructive';
    const pathMarkup = item.icon === 'check'
      ? '<path d="M20 6 9 17l-5-5"></path>'
      : '<path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>';

    li.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-${item.icon} mt-0.5 h-4 w-4 shrink-0 ${iconClass}">
        ${pathMarkup}
      </svg>
      <span>${item.text}</span>
    `;

    list.appendChild(li);
  });

  container.appendChild(list);
  return container;
}

function renderAccordionContent(panelId) {
  const panel = document.getElementById(panelId);
  const items = panelId && accordionContent[panelId];
  if (!panel || !items || panel.dataset.rendered === 'true') return;

  const wrapper = panel.querySelector('.pt-0.pb-5') || panel;
  wrapper.innerHTML = '';
  wrapper.appendChild(buildAccordionContent(items));
  panel.dataset.rendered = 'true';
}

function setPanelState(panel, nextState) {
  if (!panel) return;

  if (nextState === 'open') {
    panel.classList.remove('hidden');
    panel.hidden = false;
    panel.dataset.state = 'open';

    requestAnimationFrame(() => {
      const height = panel.scrollHeight;
      const width = panel.scrollWidth;

      panel.style.setProperty(
        '--radix-collapsible-content-height',
        `${height}px`
      );

      panel.style.setProperty(
        '--radix-collapsible-content-width',
        `${width}px`
      );

      panel.style.setProperty(
        '--radix-accordion-content-height',
        'var(--radix-collapsible-content-height)'
      );

      panel.style.setProperty(
        '--radix-accordion-content-width',
        'var(--radix-collapsible-content-width)'
      );
    });

    return;
  }

  // Store current size before closing
  panel.style.setProperty(
    '--radix-collapsible-content-height',
    `${panel.scrollHeight}px`
  );

  panel.style.setProperty(
    '--radix-collapsible-content-width',
    `${panel.scrollWidth}px`
  );

  panel.dataset.state = 'closed';

  const hidePanel = () => {
    if (panel.dataset.state === 'closed') {
      panel.classList.add('hidden');
      panel.hidden = true;
    }

    panel.removeEventListener('animationend', hidePanel);
    panel.removeEventListener('transitionend', hidePanel);
  };

  panel.addEventListener('animationend', hidePanel);
  panel.addEventListener('transitionend', hidePanel);

  // Fallback
  setTimeout(hidePanel, 300);
}

function initAccordions() {
  document.querySelectorAll('button[data-radix-collection-item]').forEach((button) => {
    const controls = button.getAttribute('aria-controls');
    const panel = controls ? document.getElementById(controls) : null;
    const wrapper = button.closest('div[data-orientation][data-state]');
    const heading = button.closest('h3[data-orientation][data-state]');

    button.addEventListener('click', () => {
      const isOpen = button.dataset.state === 'open' || button.getAttribute('aria-expanded') === 'true';
      const nextState = isOpen ? 'closed' : 'open';
      const nextExpanded = isOpen ? 'false' : 'true';

      if (panel) renderAccordionContent(panel.id);

      if (wrapper) wrapper.dataset.state = nextState;
      if (heading) heading.dataset.state = nextState;
      button.dataset.state = nextState;
      button.setAttribute('aria-expanded', nextExpanded);

      setPanelState(panel, nextState);
    });
  });
}

// init
document.addEventListener("DOMContentLoaded", () => {
  initStickyBar();
  initAccordions();
});